import axios from 'axios'
import store from './../../store'

const baseURL = process.env.VUE_APP_BASE_URL || 'https://api.diariodetreino.com/api'

let axiosApi = axios.create(
  {
    baseURL,
  },
  5000,
)
axiosApi.interceptors.request.use(
  (config) => {
    let token = store.getters.ApiToken
    //config.headers['Cache-Control'] = 'no-cache'
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    let studentId = store.getters.StudentManager
    if (studentId) {
      config.headers['student-manager'] = btoa(studentId)
    }

    let coachId = store.getters.CoachManager
    if (coachId) {
      config.headers['coach-manager'] = btoa(coachId)
    }

    let trainingPlanId = store.getters.TrainingPlanManager
    if (trainingPlanId) {
      config.headers['training-plan-manager'] = btoa(trainingPlanId)
    }

    return config
  },

  (error) => {
    store.commit('SET_SPLASH_SCREEN', false)
    return Promise.reject(error)
  },
)

// Response interceptor: 402 = coach sem plano ativo, bloqueia
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Sem isto, qualquer request que falha deixa o splash ligado pra sempre:
    // as telas so fazem commit(false) dentro do .then(), e a maioria nao tem .catch().
    store.commit('SET_SPLASH_SCREEN', false)

    if (error?.response?.status === 402) {
      store.commit('SET_REQUIRES_SUBSCRIPTION', true)
      if (typeof window !== 'undefined' && window.location.pathname !== '/assinatura') {
        window.location.href = '/assinatura'
      }
    }
    return Promise.reject(error)
  },
)

export default axiosApi
